<template>
  <!-- Cross Sell modal -->
  <div
    class="modal fade"
    id="crossSellModal"
    tabindex="-1"
    data-bs-keyboard="false"
    role="dialog"
    aria-labelledby="modalTitleId"
    aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-scrollable modal-dialog-centered"
      role="document">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <img
            class="img-fluid"
            style="max-height: 70px; margin: 0 auto;"
            :src="headerImg">
        </div>
        <!-- Content -->
        <div class="modal-body">
          <!-- Form & text blurb -->
          <div>
            <!-- General info text and get started OR download button dependent on company -->
            <div class="text-center">
              <p>{{ text }}</p>
              <p>
                <a
                  :href="link"
                  target="_blank">
                  Learn More About Our Sister Company, {{ company }}
                </a>
              </p>
              <a
                class="btn btn-primary"
                :href="docuSign"
                target="_blank">
                <i class="fa fa-handshake"/>
                Become a Customer
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>    
</template>

<script>
  import axios from 'axios'

  export default{
    inject: ['env'],
    data(){
      return{
        headerImg: this.setHeader(),
        text: this.setText(),
        docuSign: 'https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=ebd018e2-078f-465d-887f-21762c0ac044&env=na4&acct=a81cdb01-39f1-498d-a885-31b8907c10cd&v=2', 
        company: this.env.includes('EJW') ? 'Lancaster' : 'EJ Welch',
        link: this.env.includes('EJW') ? 'https://www.lancasterco.com' : 'https://www.ejwelch.com',
      }
    },
    methods:{
      setHeader(){
        let img
        if(this.env.includes('EJW')){
          img = require('../../../../assets/images/cross_sell/Become_a_Lancaster_Customer.png')
        }else{
          img = require('../../../../assets/images/cross_sell/Become_an_EJW_Customer.png')
        }
        return img
      },
      setText(){
        let txt
        if(this.env.includes('EJW')){
          txt = 'Lancaster is the premier paint sundry distributor, supplying products to retailers throughout North and South America. With seven distribution centers located in the US and Canada. Lancaster supplies over 13,000 products, from over 350 manufacturers, to more than 10,000 independent paint stores, national and regional paint chains, hardware stores, home centers and online retailers.'
        }else{
          txt = 'EJ Welch is one of the US’s largest flooring distributors, offering customers a large selection of popular favorites and trending styles. We are committed to your success and helping you win more jobs. Our sales and support staff are here to help keep your project moving, whether that be product knowledge, training, technical solutions or coordinating orders and deliveries.'
        }
        return txt
      }
    },
    computed:{
      shipTo(){return this.$store.getters.getEntity.activeShipTo}
    }
  }
</script>